import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  WorkspaceAppliedFilters,
  ParsedWorkspaceFilters,
  parseWorkspaceFilters,
  mergeWorkspaceFiltersIntoSearchParams,
  clearWorkspaceFilterParams,
  hasWorkspaceFilters,
} from '../utils/workspaceFilterParams';

export function useWorkspaceUrlFilters() {
  const [searchParams, setSearchParams] = useSearchParams();

  const parseCurrentUrl = useCallback(
    (includeAuthOnlyFilters?: boolean): ParsedWorkspaceFilters => {
      return parseWorkspaceFilters(searchParams, { includeAuthOnlyFilters });
    },
    [searchParams],
  );

  const syncAppliedFiltersToUrl = useCallback(
    (
      filters: WorkspaceAppliedFilters,
      options?: { includeAuthOnlyFilters?: boolean },
    ) => {
      const next = mergeWorkspaceFiltersIntoSearchParams(
        searchParams,
        filters,
        options,
      );
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  const clearFiltersFromUrl = useCallback(() => {
    const next = clearWorkspaceFilterParams(searchParams);
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  const urlHasFilters = useCallback(
    () => hasWorkspaceFilters(searchParams),
    [searchParams],
  );

  return {
    parseCurrentUrl,
    syncAppliedFiltersToUrl,
    clearFiltersFromUrl,
    urlHasFilters,
  };
}
